/**
 * Formats summary text for better readability
 * @param {string} summary - The summary text to format
 * @returns {string} - The formatted summary text
 */
export const formatSummaryText = (summary) => {
  if (!summary || summary === 'N/A') return 'N/A';

  return summary
    .replace(/(\d)=(\d)/g, '$1 = $2')
    .replace(/(\d+)\s*%\s*of/gi, '$1 % of')
    .replace(/(Revenue|revenue|Sales|sales)(\s*)(up to|Up to)(\s*)(\$\d+)(\s*)(=)(\s*)(\d+)(%)/g, '$1 $3 $5 = $9 $10')
    .replace(/(\d+)(\s*)(%?)(\s*)(of)(\s*)(Revenue|revenue|Sales|sales)/g, '$1% of $7')
    .replace(/\s\s+/g, ' ')
    .trim();
};
